<template>
  <ClientOnly>

    <div
      class="text-center"
      :data-testid="`monetate-carousel-${randomId}`"
    >
      <TsTypography
        as="h2"
        variant="h1"
        append-class="mb-2"
        :data-testid="`${props.title}-${randomId}`"
      >
        {{ props.title }}
      </TsTypography>
       <div class="lg:-mx-1.5" :monetate-id="props.componentName">
          <TsCarouselCardProduct
          v-if="Recommendation_productIds"
          productContextType="recommended"
          @product-click="monetateStore.trackRecommendationClick(Recommendation_productIds, $event)"
            :navigation="!isMobile"
            data-testid="product-others-carousel"
            :productIds="Recommendation_productIds.ids"
          />
        </div>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick } from "vue";
import MonetateService from "~/services/monetate.service";

const TsCarouselCardProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselCardProduct.vue')
);

const monetateStore = useMonetateStore();

type Props = {
  title: string;
  pageType: string;
  componentName: string;
};

const { isMobile, isTablet } = useDevice();
const randomId = ref<string>("");

const Recommendation_productIds = ref([]);

const props = withDefaults(defineProps<Props>(), {
  title: "Recently View",
  pageType: "faq",
  componentName: "recently-view",
});

// Local state specific to this component instance
const localPageType = ref(props.pageType);
const localComponentName = ref(props.componentName);

onMounted(async () => {
  nextTick(() => {
    randomId.value = useRandomUUID();
  });
 await fetchRecommendations();
});

// Fetch recommendations for the specific component instance
const fetchRecommendations = async () => {
  const monetate = new MonetateService();
  const event_object = [
    {
      eventType: "monetate:context:PageView",
      url: "https://www.toolstation.nl/",
      pageType: localPageType.value, // Use local state
    },
  ];
  try {
    const response = await monetate.callEngineApi(event_object);
    const action = monetate.filterActions(response, {
      actionType: "monetate:action:OmnichannelRecommendation",
    });

    const my_builder_action = getActionItems(localComponentName.value, action);
    if (my_builder_action) {
      Recommendation_productIds.value = my_builder_action; // Proper reactivity
    }
  } catch (e) {
    const {customClientErrorHandler} = await import("~/services-optimized/customErrorService");
    let errorMeta = {event_object, monetateError: true}

    customClientErrorHandler(
        e,
        'high',
        'Monetate Error - trying to fetch recommended product for carousel using fetchRecommendations()',
        errorMeta
    );
  }
};

// Watch for props changes and re-fetch recommendations
watch(
  () => [props.title, props.pageType, props.componentName],
  async () => {
    localPageType.value = props.pageType; // Sync with local state
    localComponentName.value = props.componentName; // Sync with local state
    await fetchRecommendations();
  },
  { immediate: true }
);
</script>
